import isEmpty from 'lodash/isEmpty'
import type {
  Deposit,
  Withdrawal,
  Borrow,
  Repayment,
  CollateralDeposit,
  CollateralWithdrawal,
} from '../types'

export type TransactionRelationsResponse = {
  data: {
    deposits?: Deposit[]
    withdrawals?: Withdrawal[]
    borrows?: Borrow[]
    repayments?: Repayment[]
    collateralDeposits?: CollateralDeposit[]
    collateralWithdrawals?: CollateralWithdrawal[]
  }
}

export type Args = {
  walletAddress: string
  depositIds: string[]
  withdrawalIds: string[]
  borrowIds: string[]
  repaymentIds: string[]
  collateralDepositIds: string[]
  collateralWithdrawalIds: string[]
}

export const getQueryGraphTransactionRelations = ({
  walletAddress,
  depositIds,
  withdrawalIds,
  borrowIds,
  repaymentIds,
  collateralDepositIds,
  collateralWithdrawalIds,
}: Args) =>
  [
    '{',
    !isEmpty(depositIds) &&
      `deposits(
        where: { id_in: [
          ${depositIds.map(id => `"${id}-${walletAddress}"`).join(', ')}
        ] }
      ) {
        id
        timestamp
        pool
        depositor {
          id
        }
        amount
        dtPrice
      }`,
    !isEmpty(withdrawalIds) &&
      `withdrawals(
        where: { id_in: [
          ${withdrawalIds.map(id => `"${id}-${walletAddress}"`).join(', ')}
        ] }
      ) {
        id
        timestamp
        pool
        withdrawer {
          id
        }
        amount
        dtPrice
      }`,
    !isEmpty(borrowIds) &&
      `borrows(
        where: { id_in: [
          ${borrowIds.map(id => `"${id}-${walletAddress}"`).join(', ')}
        ] }
      ) {
        id
        timestamp
        borrower {
          id
        }
        loanId {
          id
          erc20Address
        }
        amount
        duration
        collateralToken
        collateralAmount
        ltv
        lt
      }`,
    !isEmpty(repaymentIds) &&
      `repayments(
        where: { txHash_in: [
          ${repaymentIds.map(id => `"${id}"`).join(', ')}
        ] }
      ) {
        id
        loanId {
          id
          erc20Address
        }
        txHash
        timestamp
        borrower {
          id
        }
        repayer {
          id
        }
        principal
        amountRepaid
      }`,
    !isEmpty(collateralDepositIds) &&
      `collateralDeposits(
        where: { txHash_in: [
          ${collateralDepositIds.map(id => `"${id}"`).join(', ')}
        ] }
      ) {
        id
        timestamp
        txHash
        borrower { id }
        token
        amount
      }`,
    !isEmpty(collateralWithdrawalIds) &&
      `collateralWithdrawals(
        where: { txHash_in: [
          ${collateralWithdrawalIds.map(id => `"${id}"`).join(', ')}
        ] }
      ) {
        id
        timestamp
        txHash
        borrower { id }
        token
        amount
      }`,
    '}',
  ]
    .filter(Boolean)
    .join('\n')
